// src/utils/HorarioUtils.js
export const normalizarHorariosFuncionamento = (resultado) => {
  if (Array.isArray(resultado)) return resultado;
  if (Array.isArray(resultado?.horarios)) return resultado.horarios;
  return [];
};
